module.exports = __webpack_public_path__ + "static/img/jjrc.413c3315.png";